import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fund-summary',
  templateUrl: './fund-summary.component.html',
  styleUrls: ['../../fund.component.scss', './fund-summary.component.scss'],
  standalone: false
})
export class FundSummaryComponent {
  @Input() customerData;
  @Input() accountOpened;
  @Input() oneTimeInvested;
  @Input() monthlyInvested;
  @Input() iban;
  @Input() currentAccountDetails;
}
